<script>
import Color from 'color'
import avatarHairTopA from './avatar-hair-top-a'
import avatarShirtsA from './avatar-shirts-a'
import avatarContourSkinsA from './avatar-contour-a'
import avatarShirtsB from './avatar-shirts-b'
import avatarShirtsC from './avatar-shirts-c'
import avatarShirtsD from './avatar-shirts-d'
import avatarShirtsE from './avatar-shirts-e'
import avatarMoleA from './avatar-mole-a'
import avatarEyeShadowA from './avatar-eyeshadow-a'
import avatarWrinklesA from './avatar-wrinkles-a'
import avatarCheekA from './avatar-cheek-a'
import avatarCheekB from './avatar-cheek-b'
import avatarCheekC from './avatar-cheek-c'
import avatarMouthA from './avatar-mouth-a'
import avatarMouthB from './avatar-mouth-b'
import avatarBeardA from './avatar-beard-a'
import avatarNoseA from './avatar-nose-a'
import avatarNoseB from './avatar-nose-b'
import avatarNoseC from './avatar-nose-c'
import avatarEyebrowA from './avatar-eyebrow-a'
import avatarEyebrowB from './avatar-eyebrow-b'
import avatarEyebrowC from './avatar-eyebrow-c'
import avatarEyeA from './avatar-eye-a'
import avatarEyeB from './avatar-eye-b'
import avatarEyeC from './avatar-eye-c'
import avatarGlassesA from './avatar-glasses-a'
import defAvatar from './avatar-def'

import avatarHairBottomA from './avatar-hair-bottom-a'
import avatarHairBottomB from './avatar-hair-bottom-b'
import avatarHairBottomC from './avatar-hair-bottom-c'
import avatarHairBottomD from './avatar-hair-bottom-d'
import avatarHairBottomE from './avatar-hair-bottom-e'
import avatarHairBottomF from './avatar-hair-bottom-f'

export default {
  name: 'avatarLayout',
  components: {
    's-hair-top-a': avatarHairTopA,
    's-shirts-a': avatarShirtsA,
    's-contour-skin-a': avatarContourSkinsA,
    's-shirts-b': avatarShirtsB,
    's-shirts-c': avatarShirtsC,
    's-shirts-d': avatarShirtsD,
    's-shirts-e': avatarShirtsE,
    's-mole-a': avatarMoleA,
    's-eyeshadow-a': avatarEyeShadowA,
    's-wrinkles-a': avatarWrinklesA,
    's-cheek-a': avatarCheekA,
    's-cheek-b': avatarCheekB,
    's-cheek-c': avatarCheekC,
    's-avatar-def': defAvatar,
    's-mouth-a': avatarMouthA,
    's-mouth-b': avatarMouthB,
    's-beard-a': avatarBeardA,
    's-nose-a': avatarNoseA,
    's-nose-b': avatarNoseB,
    's-nose-c': avatarNoseC,
    's-eyebrow-a': avatarEyebrowA,
    's-eyebrow-b': avatarEyebrowB,
    's-eyebrow-c': avatarEyebrowC,
    's-eye-a': avatarEyeA,
    's-eye-b': avatarEyeB,
    's-eye-c': avatarEyeC,
    's-glasses-a': avatarGlassesA,
    's-hair-bottom-a': avatarHairBottomA,
    's-hair-bottom-b': avatarHairBottomB,
    's-hair-bottom-c': avatarHairBottomC,
    's-hair-bottom-d': avatarHairBottomD,
    's-hair-bottom-e': avatarHairBottomE,
    's-hair-bottom-f': avatarHairBottomF,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    convertColor(hex) {
      return Color(hex)
    },
  },
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 320 320"
  >
    <s-hair-top-a :data="data.hair" />
    <s-shirts-a :data="data.clothes" />
    <s-contour-skin-a :data="data" />
    <s-shirts-b :data="data.clothes" />
    <s-shirts-c :data="data.clothes" />
    <s-shirts-d :data="data" />
    <s-shirts-e :data="data" />
    <s-mole-a :data="data.mole" />
    <s-eyeshadow-a :data="data.eyeshadow" />
    <s-wrinkles-a :data="data.wrinkle" />
    <s-cheek-a :data="data.cheek" />
    <s-cheek-b :data="data.cheek" />
    <s-cheek-c :data="data.cheek" />
    <s-avatar-def />
    <s-mouth-a :data="data.mouth" />
    <s-mouth-b :data="data.mouth" />
    <s-beard-a :data="data" />
    <s-nose-a :data="data.nose" />
    <s-nose-b :data="data.nose" />
    <s-nose-c :data="data.nose" />
    <s-eyebrow-a :data="data.eyebrows" />
    <s-eyebrow-b :data="data.eyebrows" />
    <s-eyebrow-c :data="data.eyebrows" />
    <s-eye-a :data="data.eyes" />
    <s-eye-b :data="data.eyes" />
    <s-eye-c :data="data.eyes" />
    <s-glasses-a :data="data.glasses" />
    <s-hair-bottom-a :data="data.hair" />
    <s-hair-bottom-b :data="data.hair" />
    <s-hair-bottom-c :data="data.hair" />
    <s-hair-bottom-d :data="data.hair" />
    <s-hair-bottom-e :data="data.hair" />
    <s-hair-bottom-f :data="data.hair" />
  </svg>
</template>
